import { render, staticRenderFns } from "./js-error.vue?vue&type=template&id=01593fc0&scoped=true&"
import script from "./js-error.vue?vue&type=script&lang=js&"
export * from "./js-error.vue?vue&type=script&lang=js&"
import style0 from "./js-error.vue?vue&type=style&index=0&id=01593fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01593fc0",
  null
  
)

export default component.exports